import { Action } from "@ngrx/store";
import { Dictionary } from "../models/common_types";
import { BrokerDetail, AuditCallBool } from "../models/global-subheader.model";

export const PAGE_NAME_CHANGED = "PAGE_NAME_CHANGED";
export const SUBHEADER_TITLE_CHANGED = "SUBHEADER_TITLE_CHANGED";
export const SET_BROKER_LIST = "SET_BROKER_LIST";
export const SET_ENTITLEMENT_LIST = "SET_ENTITLEMENT_LIST";
export const TICKER_CHANGED = "TICKER_CHANGED";
export const SUBHEADER_CHANGED = "SUBHEADER_CHANGED";
export const SET_DP_PARAMS = "SET_DP_PARAMS";
export const DELETE_DP_PARAMS = "DELETE_DP_PARAMS";
export const SET_AUDIT_CALL_FBAR = "SET_AUDIT_CALL_FBAR";
export const SET_DISABLE_ACTIONS = "SET_DISABLE_ACTIONS";
export const SET_REVISION_DATE_FOR_EXPORT = "SET_REVISION_DATE_FOR_EXPORT";

export class PageNameChanged implements Action {
  readonly type = PAGE_NAME_CHANGED;
  constructor(public payload: string) {}
}

export class SubheaderTitleChanged implements Action {
  readonly type = SUBHEADER_TITLE_CHANGED;
  constructor(public payload: Dictionary<string>) {}
}

export class SetBrokerList implements Action {
  readonly type = SET_BROKER_LIST;
  constructor(public payload: Array<BrokerDetail>) {}
}
export class SetEntitlementList implements Action {
  readonly type = SET_ENTITLEMENT_LIST;
  constructor(public payload: Array<BrokerDetail>) {}
}
export class TickerChanged implements Action {
  readonly type = TICKER_CHANGED;
  constructor(public payload: string) {}
}

export class SubheaderChanged implements Action {
  readonly type = SUBHEADER_CHANGED;
}

export class SetDpParams implements Action {
  readonly type = SET_DP_PARAMS;
  constructor(public payload: Dictionary<any>) {}
}

export class DeleteDpParams implements Action {
  readonly type = DELETE_DP_PARAMS;
}

export class SetAuditCallFbar implements Action {
  readonly type = SET_AUDIT_CALL_FBAR;
  constructor(public payload: AuditCallBool) {}
}

export class SetDisableActions implements Action {
  readonly type = SET_DISABLE_ACTIONS;
  constructor(public payload: boolean) {}
}

export class SetRevisionDateForExport implements Action {
  readonly type = SET_REVISION_DATE_FOR_EXPORT;
  constructor(public payload: string) {}
}

export type Actions =
  | PageNameChanged
  | SubheaderTitleChanged
  | SetBrokerList
  | SetEntitlementList
  | TickerChanged
  | SubheaderChanged
  | SetDpParams
  | DeleteDpParams
  | SetAuditCallFbar
  | SetDisableActions
  | SetRevisionDateForExport;
